import { proyectUrl } from 'proyectUrl';

export const strings = {
  english: {
    title: 'CREATE AN ACCOUNT',
    name: 'Name *',
    email: 'Email address *',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    describes: 'What best describe you?',
    individual: 'Individual',
    company: 'Company',
    newsletter: 'Subscribe to our newsletter',
    policy: 'Privacy Policy',
    terms: 'Terms of Service',
    policyLink: `${proyectUrl()}/privacy-policy/`,
    termsLink: `${proyectUrl()}/terms-of-service/`,
    signUp: 'CREATE ACCOUNT',
    or: 'Or',
    facebook: 'Create my account with Facebook',
    google: 'Create my account with google',
  },

  japan: {
    title: 'アカウントを作成する',
    name: 'お名前 *',
    email: 'メールアドレス *',
    password: 'パスワード *',
    confirmPassword: 'パスワード(確認) *',
    describes: '使用目的',
    individual: '企業用',
    company: '個人用',
    newsletter: 'ニュースレターの購読について',
    policy: ' プライバシーポリシー',
    terms: ' 利用規約に同意します ',
    policyLink: `${proyectUrl()}/ja/%e3%83%97%e3%83%a9%e3%82%a4%e3%83%90%e3%82%b7%e3%83%bc%e3%83%9d%e3%83%aa%e3%82%b7%e3%83%bc/`,
    termsLink: `${proyectUrl()}/terms-of-service/`,
    signUp: 'アカウントを作成する',
    or: 'または',
    facebook: 'Facebookを使ってアカウント登録する',
    google: 'Googleを使ってアカウント登録する',
  },
};
